/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable import/prefer-default-export */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Icon } from '../icon/Icon';
import { makeCollapse, makeCollapseToggle, makeCollapseContent, makeToggleIcon } from './mixins';
const CollapseComponent = styled.div `
  ${props => makeCollapse(props)}
`;
const CollapseToggle = styled.div `
  ${props => makeCollapseToggle(props)}
`;
const CollapseContent = styled.div `
  ${props => makeCollapseContent(props)}
`;
const ToggleIcon = styled(Icon) `
  ${props => makeToggleIcon(props)}
`;
export const Collapse = props => {
    const { children, toggleLabel, collapsed, offset, disabled, toggleIcon } = props;
    const externalState = disabled ? false : collapsed;
    const [internalState, setInternalStatus] = useState(collapsed);
    return (React.createElement(CollapseComponent, { collapsed: collapsed },
        toggleLabel && (React.createElement(CollapseToggle, { onClick: () => setInternalStatus(disabled ? internalState : !internalState) },
            toggleIcon && React.createElement(ToggleIcon, { collapsed: internalState, name: toggleIcon, size: "20", color: "black" }),
            toggleLabel)),
        React.createElement(CollapseContent, { collapsed: !disabled && externalState && (!toggleLabel || internalState), offset: offset }, children)));
};
Collapse.propTypes = {
    children: PropTypes.node.isRequired,
    toggleLabel: PropTypes.node,
    collapsed: PropTypes.bool,
    disabled: PropTypes.bool,
    offset: PropTypes.number,
    toggleIcon: PropTypes.string,
};
Collapse.defaultProps = {
    collapsed: true,
    disabled: false,
    offset: 0,
    toggleIcon: '',
    toggleLabel: null,
};
